/* eslint-disable jsx-a11y/control-has-associated-label */
import { NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';
import IC_LOGO from '../assets/ic_logo.svg';
import WalletConnectDialog from './WalletConnectDialog';
import { motion } from 'framer-motion';

const NAV_LIST = [
  {
    label: 'About Us',
    path: '/',
  },
  {
    label: 'How to buy',
    path: '/how-to-buy',
  },
  {
    label: 'Roadmap',
    path: '/roadmap',
  },
  {
    label: 'FAQ',
    path: '/faq',
  },
  {
    label: 'Country',
    path: '/country',
  },
];

function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <WalletConnectDialog isOpen={isOpen} onCancel={() => setIsOpen(false)} />
      <div className="navbar d-flex justify-content-between p-0 py-2 align-items-center">
        <div className="container">
          <NavLink to="/">
            <img src={IC_LOGO} alt="logo" style={{ width: 120 }} />
          </NavLink>
          <div className="column-gap-4 align-items-center d-none d-lg-flex">
            {NAV_LIST.map((model) => <NavLink className={({ isActive }) => `nav ${isActive ? 'nav-active' : ''}`} to={model.path}>{model.label}</NavLink>)}
            <NavLink className="nav">English ▼</NavLink>
            <motion.button whileTap={{ scale: 0.85 }} className="primary-button py-2 fs-small" type="button" onClick={() => setIsOpen(true)}>Connect wallet</motion.button>
          </div>
          <div className="d-block d-lg-none">
            <button type="button" className="border-0 bg-transparent text-white fs-3" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-list" />
            </button>
          </div>
        </div>
      </div>
      <div className="offcanvas offcanvas-end navbar-offcanvas" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header py-2 d-flex align-items-center justify-content-between">
          <a href="/">
            <img src={IC_LOGO} alt="logo" style={{ width: 120 }} />
          </a>
          <button type="button" className="border-0 bg-transparent text-white fs-3" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="divider" />
        <div className="offcanvas-body">
          <div className=" d-flex flex-column pt-3">
            {NAV_LIST.map((model) => (
              <>
                <a className={`fs-6 nav ${location.pathname === model.path && 'nav-active'}`} href={model.path}>{model.label}</a>
                <div className="divider mt-2 mb-3" />
              </>
            ))}
            <a className="nav fs-6" href="\" onClick={(event) => event.preventDefault()}>English ▼</a>
            <motion.button whileTap={{ scale: 0.85 }} className="primary-button py-2 fs-6 mx-auto mt-4" type="button" onClick={() => setIsOpen(true)}>Connect wallet</motion.button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
